//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("logbook", LogbookFactory);

    LogbookFactory.$inject = ["apiClientFactory"];
    function LogbookFactory(apiClientFactory) {

        const routePrefix = "api/Logbook/";

        return {
            CreateEntry: apiClientFactory.post(routePrefix + "Create/"),
            DeleteEntry: apiClientFactory.delete(routePrefix + "Delete/"),
        };
    }
})();
